const SHOW_NOTICATIONS = "SHOW_NOTICATIONS";
const STOP_NOTIFICATIONS = "STOP_NOTIFICATIONS";

// Define reducer function
const notificationReducer = (state = { showNotifications: false }, action) => {
  switch (action.type) {
    case SHOW_NOTICATIONS:
      return {
        ...state,
        showNotifications: true,
      };
    case STOP_NOTIFICATIONS:
      return {
        ...state,
        showNotifications: false,
      };
    default:
      return state;
  }
};

const show_notifications = () => ({
  type: SHOW_NOTICATIONS,
});

const stop_notications = () => ({
  type: STOP_NOTIFICATIONS,
});

export { show_notifications, stop_notications };
export default notificationReducer;
